import BookItem from '../common/bookItem';
import { mouseEvent } from '../common/mouse_event';
import PlaySound from './play_sound';
import ReadController from './read_controller';
import { PLAYER_TYPE } from './player_type';
export default class ReadMultipleSentence extends PlaySound {
    constructor(el, target) {
        super(el, target);
        console.dir("el:", el);
        this.targetGroups = el.targetGroup.replace(/\[*\]*/g, '').split(",");
        this.currentGroupIndex = 0;
        this.checkGroups = [];
        for(let i = 0; i < this.targetGroups.length; i++) {
            this.checkGroups.push(false);
        }
        this.sentences = [];
        this.playerType = PLAYER_TYPE.FULL;
    }

    init() {
        mouseEvent.add_mouse_event(this);
    }

    trigger() {
        super.trigger();

        ReadController.Instance.sentenceGroups = this.targetGroups;
        ReadController.Instance.trigger();
    }
}